<template>
  <div>
    <table class="inventory-table">
      <tr> 
        <th>Image</th>
        <th>Name</th>
        <th>Action</th>
        <th>Quantity</th>
        <th># In Room</th>
      </tr>
      <tr v-for="ownedLootItemId in myFilteredOwnedLootItemIds" :key="ownedLootItemId">
        <td style="height:30px;"><img class="item-image" v-if="lootItemForOwnedLootItemId(ownedLootItemId).image_url" :src="lootItemImageUrl(lootItemForOwnedLootItemId(ownedLootItemId))"/></td>
        <td>{{lootItemForOwnedLootItemId(ownedLootItemId).name}}</td>
        <td><slot name="actions" v-bind:ownedLootItem="ownedLootItemForId(ownedLootItemId)" v-bind:lootItem="lootItemForOwnedLootItemId(ownedLootItemId)">
          - 
        </slot></td>
        <td>{{ownedLootItemForId(ownedLootItemId).quantity}}</td>
        <td><slot name="numberInRoom" v-bind:ownedLootItem="ownedLootItemId" v-bind:lootItem="lootItemForOwnedLootItemId(ownedLootItemId)">
          0 
        </slot></td>
      </tr>
      <tr>
        <td style="padding:10px;" colspan="5">Want more items for your room? Check out the <router-link to="/loot-shop">LOOT SHOP</router-link></td>
      </tr>
    </table>
  </div>
</template>

<script>
import Vue from 'vue'
import { mapState } from 'vuex'

export default {
  name: 'InventoryBrowser',
  props: ['filterCategories'],
  async created () {
    console.log('InventoryBrowser Created')
    // await this.refreshOwnedLootItems()
  },
  mounted () {
    if (this.user) {
      this.refreshOwnedLootItems()
    }
  },
  data () {
    return {
      ownedLootItemsFetched: false,
      todo: 'todfooo'
    }
  },
  computed: Object.assign(mapState([
    'myOwnedLootItemIds',
    'currentUser'
  ]), {
    user () {
      return this.currentUser
    },
    myFilteredOwnedLootItemIds () {
      return this.myOwnedLootItemIds.filter(olid => {
        let li = this.lootItemForOwnedLootItemId(olid)
        return li.category === 'roomItem'
      })
    }
  }),
  methods: {
    lootItemImageUrl (lootItem) {
      return `${Vue.config.WEB_ASSET_BASE_URL}/${lootItem.image_url}`
    },
    refreshOwnedLootItems () {
      if (this.ownedLootItemsFetched === false) {
        this.ownedLootItemsFetched = true
        console.log('Refreshing Owned Loot Items')
        this.$store.dispatch('fetchOwnedLootItems')
      }
    },
    ownedLootItemForId (id) {
      return this.$store.state.ownedLootItems[id]
    },
    lootItemForOwnedLootItemId (id) {
      return this.lootItemForId(this.ownedLootItemForId(id).loot_item_id)
    },
    lootItemForId (id) {
      return this.$store.state.lootItems[id]
    }
  },
  watch: {
    async user () {
      await Vue.nextTick()
      this.refreshOwnedLootItems()
    }
  }
}
</script>

<style scoped>
  .item-image {
    height: 100%;
  }
  .inventory-table {
    min-width: 500px;
    max-width: 1000px;
    margin-left: auto;
    margin-right: auto;
    padding: 10px;
    width: 100%;
    font-size: 12px;
  }

  .inventory-table tr:nth-child(even){
    background-color:#5a5a61;
  }
  .inventory-table tr:nth-child(odd){
    background-color:#484444;
  }
</style>


// WEBPACK FOOTER //
// src/components/InventoryBrowser.vue